import React from 'react';
import {connect} from 'react-redux';

class Bar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={`bar w-100 p-2 bg-white border-bottom shadow-sm d-flex ${this.props.middleCenter ? 'align-items-center' : ''} ${this.props.mobileColumn ? 'filter-bar-wrapper' : ''}`}>
                {this.props.children}
            </div>
        );

    }
}

function mapStateToProps(state) {
    return {state: state}
}

export default connect(mapStateToProps)(Bar);
